import PropTypes from 'prop-types';
import { Form } from 'react-bulma-components';

import './checkbox.scss';

const { Field, Checkbox } = Form;

const CustomCheckboxV2 = (props) => {
    const { label, name, checked, disabled, required, onChange } = props;

    return (
        <Field className='custom-checkbox__container'>
            <Checkbox name={name} checked={checked} onChange={onChange} disabled={disabled}>
                <span>
                    {label}
                    {required && <span className='required-mark'>*</span>}
                </span>
            </Checkbox>
        </Field>
    );
};

export default CustomCheckboxV2;

CustomCheckboxV2.propTypes = {
    label: PropTypes.node,
    name: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    errors: PropTypes.array,
    required: PropTypes.bool,
    disabled: PropTypes.bool
};
